export default __webpack_public_path__ + "static/media/Location-Blue-24x24.e4d8a5c6.svg";